import CheckboxGroup from '../checkbox/src/checkbox-group.vue'

export default CheckboxGroup
